<template>
  <div>
    <input-form
      :inputData="birthInfoFormList"
      @toParentVal="searchBirthInfo"
      :btnPosition1="true"
      style="margin: 20px 0"
    >
    </input-form>
    <div class="mb12">
      <el-button
        style="width: auto"
        @click="addCrowd"
        :disabled="!birthInfoList.length"
        >按查询结果生成人群</el-button
      >
      <el-button @click="exportBirth" type="primary" v-preventReClick
        >导出</el-button
      >
    </div>
    <!-- 表格 -->
    <el-table
      :data="birthInfoList"
      style="width: 100%;"
      :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
      :cell-style="{ 'text-align': 'left' }"
      v-loading="loading"
    >
      <template slot="empty">
        <div>
          <img
            src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
          />
          <span style="margin-left: -140px">暂无任何数据</span>
        </div>
      </template>
      <el-table-column prop="chaosPin" label="用户pin（加密）" width="150">
      </el-table-column>
      <el-table-column prop="memberNick" label="用户昵称"> </el-table-column>
      <el-table-column prop="activityName" label="活动名称"> </el-table-column>
      <el-table-column prop="birthDay" label="登记生日">
        <template slot-scope="scope">
          <span>{{ scope.row.birthDay ? scope.row.birthDay : "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="登记时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime ? scope.row.createTime : "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sellerLinkName" label="投放渠道"></el-table-column>
    </el-table>
    <el-pagination
      style="text-align: right; margin: 25px"
      @size-change="handleSizeChange"
      background
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :page-size="birthInfoForm.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="birthInfoTotal"
      :current-page="birthInfoForm.current"
    ></el-pagination>
  </div>
</template>
<script>
import { getBirthdayInfo } from "@/api/integralCenter/PointActivityAnalyticController";
import inputForm from "@/components/inputForm.vue";
export default {
  name: "birthInfo",
  components: {
    inputForm,
  },
  props: {
    activityId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isShowExport: false,
      loading: false,
      birthInfoTotal: 0,
      birthInfoList: [],
      birthInfoForm: {
        sellerLinkId: "",
        customerPin: "",
        memberNick: "",
        registerStartTime: "",
        registerEndTime: "",
        birthStartTime: "",
        birthEndTime: "",
        size: 10,
        current: 1,
      },
      birthInfoFormList: [
        {
          name: "用户PIN：",
          val: "customerPin",
          placeholder: "请输入用户PIN",
        },
        {
          name: "用户昵称：",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "登记时间：",
          myDate: true,
          val: ["registerStartTime", "registerEndTime"],
          startKey: "registerStartTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: false,
        },
        {
          name: "生日时间：",
          myDate: true,
          val: ["birthStartTime", "birthEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: false,
        },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getBirthInfoDetail();
  },
  methods: {
    addCrowd() {
      this.$emit("addCrowd", 52);
    },
    exportBirth() {
      this.$emit("exportTheData");
    },
    handleSizeChange(val) {
      this.birthInfoForm.size = val;
      this.getBirthInfoDetail();
    },
    handleCurrentChange(val) {
      this.birthInfoForm.current = val;
      this.getBirthInfoDetail();
    },
    getBirthInfoDetail() {
      this.loading = true;
      getBirthdayInfo({ ...this.birthInfoForm, activityId: this.activityId })
        .then((res) => {
          this.loading = false;
          if (res.code == 1) {
            this.birthInfoList = res.data.records || [];
            this.birthInfoTotal = +res.data.total;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    searchBirthInfo(val) {
      this.birthInfoForm.customerPin = val.customerPin ? val.customerPin : "";
      this.birthInfoForm.memberNick = val.memberNick ? val.memberNick : "";
      this.birthInfoForm.registerStartTime = val.registerStartTime
        ? val.registerStartTime
        : "";
      this.birthInfoForm.registerEndTime = val.registerEndTime
        ? val.registerEndTime
        : "";
      this.birthInfoForm.birthStartTime = val.birthStartTime
        ? val.birthStartTime
        : "";
      this.birthInfoForm.birthEndTime = val.birthEndTime
        ? val.birthEndTime
        : "";
      this.birthInfoForm.sellerLinkId = val.sellerLinkId
        ? val.sellerLinkId
        : "";
      this.birthInfoForm.size = 10;
      this.birthInfoForm.current = 1;
      this.getBirthInfoDetail();
    },
  },
};
</script>
<style lang="scss" scoped>
.mb12 {
  margin-bottom: 16px;
}
</style>
